export const PixKeyFormatHelper = () => (
  <a
    className="text-white"
    href="https://www.bcb.gov.br/content/estabilidadefinanceira/pix/Regulamento_Pix/X_ManualOperacionaldoDICT.pdf#page=14"
    target="_blank"
  >
    Duvidas sobre o formato da chave?
  </a>
);
